import React from "react";

const AdminBuilderContext = React.createContext({});

export default AdminBuilderContext;
